import { defineMessages, IntlShape } from 'react-intl';
import type { Music24PlanTier } from 'fym-common/src/license/music24Plans';

const planMessages = defineMessages({
  free: { id: 'app.sml.team.accept.plan.free', defaultMessage: 'Free plan' },
  trial: { id: 'app.sml.team.accept.plan.trial', defaultMessage: 'Free trial' },
  artist: { id: 'app.sml.team.accept.plan.artist', defaultMessage: 'Plus plan' },
  pro: { id: 'app.sml.team.accept.plan.pro', defaultMessage: 'Pro plan' },
  plug: { id: 'app.sml.team.accept.plan.plug', defaultMessage: 'Plug plan' },
  manager: { id: 'app.sml.team.accept.plan.manager', defaultMessage: 'Max plan' },
  label: { id: 'app.sml.team.accept.plan.label', defaultMessage: 'Ultra plan' },
});

/** "Manager plan", as the accept page names a workspace's plan. */
export function teamPlanLabel(intl: IntlShape, plan: Music24PlanTier): string {
  return intl.formatMessage(planMessages[plan]);
}

export const acceptMessages = defineMessages({
  // design: workspaces c5. The title, and the message of a join that finds a membership row.
  alreadyMember: { id: 'app.sml.team.accept.alreadyMemberNote', defaultMessage: 'You are already in {workspace}.' },
  // design: workspaces c6.
  workspaceFull: {
    id: 'app.sml.team.accept.workspaceFull',
    defaultMessage: '{workspace} is full. Ask the owner to free a seat or upgrade, then open this link again.',
  },
});

/** c6's sentence: the invitee cannot upgrade the workspace, so the owner must free a seat or upgrade. */
export function teamFullMessage(intl: IntlShape, workspaceName: string): string {
  return intl.formatMessage(acceptMessages.workspaceFull, { workspace: workspaceName });
}
